export default {"src":"/_next/static/media/stock.8359aeef.svg","height":267,"width":267,"blurWidth":0,"blurHeight":0};